export default {
  props: {
    resultadoValidacao: {
      type: Object,
      required: true
    },
    statusConjuntos: {
      type: Boolean,
      default: false
    },
    transporMatriz: {
      type: Boolean,
      default: false
    },
    backgroundOk: {
      type: String,
      default: '#C6EFCE'
    },
    backgroundErroNaoCritico: {
      type: String,
      default: '#FFF176'
    },
    backgroundErroCritico: {
      type: String,
      default: '#FFC7CE'
    },
    corTextoOk: {
      type: String,
      default: '#006100'
    },
    corTextoErroNaoCritico: {
      type: String,
      default: '#424242'
    },
    corTextoErroCritico: {
      type: String,
      default: '#9C0006'
    }
  },
  methods: {
    getBackgroundColorByStatus(status) {
      if (status === 'OK') return this.backgroundOk;
      if (status === 'ERRO_NAO_CRITICO') return this.backgroundErroNaoCritico;
      return this.backgroundErroCritico;
    },
    getTextColorByStatus(status) {
      if (status === 'OK') return this.corTextoOk;
      if (status === 'ERRO_NAO_CRITICO') return this.corTextoErroNaoCritico;
      return this.corTextoErroCritico;
    }
  },
  computed: {
    meses() {
      return ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    },
    camposDec() {
      return [
        'dec_01',
        'dec_02',
        'dec_03',
        'dec_04',
        'dec_05',
        'dec_06',
        'dec_07',
        'dec_08',
        'dec_09',
        'dec_10',
        'dec_11',
        'dec_12'
      ];
    },
    camposFec() {
      return [
        'fec_01',
        'fec_02',
        'fec_03',
        'fec_04',
        'fec_05',
        'fec_06',
        'fec_07',
        'fec_08',
        'fec_09',
        'fec_10',
        'fec_11',
        'fec_12'
      ];
    }
  }
};
